import React, { createContext, useState } from 'react';
import { OrderType } from '../../../components/v2/searchHelpers';

interface PeriodicFiltersContextData {
  submit: number;
  updateData: () => void;

  order: OrderType;
  setOrder: (v: OrderType) => void;

  page: Number;
  setPage: (v: Number) => void;

  advancedVisible: boolean;
  advancedData: any;
  setAdvancedVisible: (v: boolean) => void;
  setAdvancedData: (v: object[]) => void;

  areaVisible: boolean;
  areaSearchValue: string;
  areaLoading: boolean;
  areaLoaded: boolean;
  areaError: boolean;
  areaData: any;
  areaRI: number;
  setAreaVisible: (v: boolean) => void;
  setAreaSearchValue: (v: string) => void;
  setAreaLoading: (v: boolean) => void;
  setAreaLoaded: (v: boolean) => void;
  setAreaError: (v: boolean) => void;
  setAreaData: (v: any) => void;
  setAreaRI: (v: number) => void;

  dateVisible: boolean;
  dateLoading: boolean;
  dateLoaded: boolean;
  dateError: boolean;
  dateData: any;
  dateRI: number;
  setDateVisible: (v: boolean) => void;
  setDateLoading: (v: boolean) => void;
  setDateLoaded: (v: boolean) => void;
  setDateError: (v: boolean) => void;
  setDateData: (v: any) => void;
  setDateRI: (v: number) => void;

  authorVisible: boolean;
  authorSearchValue: string;
  authorLoading: boolean;
  authorLoaded: boolean;
  authorError: boolean;
  authorData: any;
  authorRI: number;
  setAuthorVisible: (v: boolean) => void;
  setAuthorSearchValue: (v: string) => void;
  setAuthorLoading: (v: boolean) => void;
  setAuthorLoaded: (v: boolean) => void;
  setAuthorError: (v: boolean) => void;
  setAuthorData: (v: any) => void;
  setAuthorRI: (v: number) => void;

  periodicVisible: boolean;
  periodicSearchValue: string;
  periodicLoading: boolean;
  periodicLoaded: boolean;
  periodicError: boolean;
  periodicData: any;
  periodicRI: number;
  setPeriodicVisible: (v: boolean) => void;
  setPeriodicSearchValue: (v: string) => void;
  setPeriodicLoading: (v: boolean) => void;
  setPeriodicLoaded: (v: boolean) => void;
  setPeriodicError: (v: boolean) => void;
  setPeriodicData: (v: any) => void;
  setPeriodicRI: (v: number) => void;

  appTypeVisible: boolean;
  appTypeSearchValue: string;
  appTypeData: any;
  setAppTypeVisible: (v: boolean) => void;
  setAppTypeSearchValue: (v: string) => void;
  setAppTypeData: (v: any) => void;
}

export const PeriodicFiltersContext = createContext<PeriodicFiltersContextData>(
  {} as PeriodicFiltersContextData
);

export const PeriodicFiltersProvider: React.FC = ({ children }) => {
  const [submit, setSubmit] = useState<number>(0);
  const [order, setOrder] = useState<OrderType>('date:desc');
  const [page, setPage] = useState<Number>(1);

  const [advancedVisible, setAdvancedVisible] = useState<boolean>(false);
  const [advancedData, setAdvancedData] = useState<object[]>([
    { type: 'AND', text: '', exact: false, searchInTitle: false }
  ]);

  const [dateVisible, setDateVisible] = useState<boolean>(false);
  const [dateLoading, setDateLoading] = useState<boolean>(false);
  const [dateLoaded, setDateLoaded] = useState<boolean>(false);
  const [dateError, setDateError] = useState<boolean>(false);
  const [dateData, setDateData] = useState<any>([]);
  const [dateRI, setDateRI] = useState<number>(0);

  const [areaVisible, setAreaVisible] = useState<boolean>(false);
  const [areaSearchValue, setAreaSearchValue] = useState<string>('');
  const [areaLoading, setAreaLoading] = useState<boolean>(false);
  const [areaLoaded, setAreaLoaded] = useState<boolean>(false);
  const [areaError, setAreaError] = useState<boolean>(false);
  const [areaData, setAreaData] = useState<any>([]);
  const [areaRI, setAreaRI] = useState<number>(0);

  const [authorVisible, setAuthorVisible] = useState<boolean>(false);
  const [authorSearchValue, setAuthorSearchValue] = useState<string>('');
  const [authorLoading, setAuthorLoading] = useState<boolean>(false);
  const [authorLoaded, setAuthorLoaded] = useState<boolean>(false);
  const [authorError, setAuthorError] = useState<boolean>(false);
  const [authorData, setAuthorData] = useState<any>([]);
  const [authorRI, setAuthorRI] = useState<number>(0);

  const [periodicVisible, setPeriodicVisible] = useState<boolean>(false);
  const [periodicSearchValue, setPeriodicSearchValue] = useState<string>('');
  const [periodicLoading, setPeriodicLoading] = useState<boolean>(false);
  const [periodicLoaded, setPeriodicLoaded] = useState<boolean>(false);
  const [periodicError, setPeriodicError] = useState<boolean>(false);
  const [periodicData, setPeriodicData] = useState<any>([]);
  const [periodicRI, setPeriodicRI] = useState<number>(0);

  const appTypeValues = [
    { key: 'doctrine', value: 'Doutrina' },
    { key: 'jurisprudence', value: 'Jurisprudência' }
  ];
  const [appTypeVisible, setAppTypeVisible] = useState<boolean>(false);
  const [appTypeSearchValue, setAppTypeSearchValue] = useState<string>('');
  const [appTypeData, setAppTypeData] = useState<any>(appTypeValues);

  const updateData = () => setSubmit(submit + 1);

  return (
    <PeriodicFiltersContext.Provider
      value={{
        submit,
        updateData,

        order,
        setOrder,

        page,
        setPage,

        advancedData,
        advancedVisible,
        setAdvancedData,
        setAdvancedVisible,

        dateData,
        dateError,
        dateLoaded,
        dateLoading,
        dateRI,
        dateVisible,
        setDateData,
        setDateError,
        setDateLoaded,
        setDateLoading,
        setDateRI,
        setDateVisible,

        areaData,
        areaError,
        areaLoaded,
        areaLoading,
        areaRI,
        areaSearchValue,
        areaVisible,
        setAreaData,
        setAreaError,
        setAreaLoaded,
        setAreaLoading,
        setAreaRI,
        setAreaSearchValue,
        setAreaVisible,

        authorData,
        authorError,
        authorLoaded,
        authorLoading,
        authorRI,
        authorSearchValue,
        authorVisible,
        setAuthorData,
        setAuthorError,
        setAuthorLoaded,
        setAuthorLoading,
        setAuthorRI,
        setAuthorSearchValue,
        setAuthorVisible,

        periodicData,
        periodicError,
        periodicLoaded,
        periodicLoading,
        periodicRI,
        periodicSearchValue,
        periodicVisible,
        setPeriodicData,
        setPeriodicError,
        setPeriodicLoaded,
        setPeriodicLoading,
        setPeriodicRI,
        setPeriodicSearchValue,
        setPeriodicVisible,

        appTypeVisible,
        appTypeSearchValue,
        appTypeData,
        setAppTypeVisible,
        setAppTypeSearchValue,
        setAppTypeData
      }}>
      {children}
    </PeriodicFiltersContext.Provider>
  );
};
